import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { treasuryTheme } from '@/themes/treasury-theme'

// Import components
import { TreasuryDataGrid } from '@/components/DataGrid/TreasuryDataGrid'
// import { ProgramacionPagosResult, ProgramacionPagosConfirmar } from '@/components/ProgramacionPagos'
import { ReusableResultTable } from '@/components/Common/ReusableResultTable'
import { ActualizarProveedoresResult } from '@/components/ActualizarProveedores/ActualizarProveedoresResult'
import { ActualizarCuentasResult } from '@/components/ActualizarCuentas/ActualizarCuentasResult'
import { ActualizarSaldosResult } from '@/components/ActualizarSaldos/ActualizarSaldosResult'
import JobsDashboardResult from '@/components/JobsDashboard/JobsDashboardResult'
import { AutorizarCPConfirmar, AutorizarCPPreview } from '@/components/AutorizarCP'
import { ActualizarFacturasPreview } from './components/ActualizarFacturas'
import ReporteFacturasResult from './components/ReporteFacturas/ReporteFacturasResult'
import ActualizarEquivalenciasResult from './components/ActualizarEquivalencias/ActualizarEquivalenciasResult'
import ActualizarProyectosResult from './components/ActualizarProyectos/ActualizarProyectosResult'
import { UserManagement } from './components/UserManagement'
import { ProjectAssignment } from './components/ProjectAssignment'
import { UserProfile } from './components/UserProfile'
import { MicrosoftSignInButton, AzureAuthProvider } from './components/AzureAuth'

// Component registry
const componentRegistry = {
  TreasuryDataGrid,
  // ProgramacionPagosResult,
  // ProgramacionPagosConfirmar,
  ReusableResultTable,
  ActualizarProveedoresResult,
  ActualizarCuentasResult,
  ActualizarSaldosResult,
  JobsDashboardResult,
  AutorizarCPConfirmar,
  AutorizarCPPreview,
  ActualizarFacturasPreview,
  ReporteFacturasResult,
  ActualizarEquivalenciasResult,
  ActualizarProyectosResult,
  UserManagement,
  ProjectAssignment,
  UserProfile,
  MicrosoftSignInButton,
  AzureAuthProvider
}

// Initialize React components when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Auto-mount components found in the DOM
  const reactMounts = document.querySelectorAll('[data-react-component]')
  
  reactMounts.forEach((element, index) => {
    const componentName = element.getAttribute('data-react-component')
    const propsJson = element.getAttribute('data-react-props')
    
    // Parse props from JSON if provided
    let props = {}
    if (propsJson) {
      try {
        props = JSON.parse(propsJson)
      } catch (e) {
        console.error('Error parsing React component props:', e)
        console.error('Raw props JSON that failed to parse:', propsJson);
        return
      }
    }
    
    // Get component from registry
    const Component = componentRegistry[componentName as keyof typeof componentRegistry]
    
    if (!Component) {
      console.error(`React component "${componentName}" not found in registry`)
      console.error('Available components:', Object.keys(componentRegistry));
      return
    }
    
    
    // Create root and render with theme provider
    const root = ReactDOM.createRoot(element as HTMLElement)
    
    root.render(
      <ThemeProvider theme={treasuryTheme}>
        <CssBaseline />
        <Component {...(props as any)} />
      </ThemeProvider>
    )
    
  })
})